import { useQuery } from '@apollo/client';
import {
  GET_DASHBOARD_PROJECT_CONTEXT,
  DashboardProjectContextData,
  DashboardProjectContextVars,
  DashboardProjectContext,
  DashboardProjectAccess
} from './projectContextQueries';

type Args = {
  projectId?: string;
  apiKey?: string;
  organizationId?: string;
};

export const useProjectContext = ({
  projectId,
  apiKey,
  organizationId
}: Args): {
  projectContext: DashboardProjectContext | null;
  accessTo: DashboardProjectAccess | null;
  loading: boolean;
} => {
  const skip = !projectId || !apiKey || !organizationId;

  const { data, loading } = useQuery<
    DashboardProjectContextData,
    DashboardProjectContextVars
  >(GET_DASHBOARD_PROJECT_CONTEXT, {
    variables: {
      projectId: projectId || '',
      apiKey: apiKey || '',
      organizationId: organizationId || ''
    },
    skip,
    fetchPolicy: 'cache-first'
  });

  return {
    projectContext: data?.currentUser.userProject || null,
    accessTo: data?.currentUser.accessTo || null,
    loading: skip ? false : loading
  };
};
